/* wsapi3-manufacturers v1.0 */
/* Deploy Version 2026-10-14 10:42:33 */
/* Deploy Version 2026-09-24 19:11:11 */
/* Deploy Version 2026-07-27 16:11:02 */
wsMain.createModule({
  name: "manufacturer",
  version: '1.0',
  updatedAt: '2026-07-14',
  function: "get",
  async get() {
    let tag = document.querySelectorAll('[data-wsjs-module="manufacturer"]');
    if (!tag || tag.length == 0) return true;

    // Âncoras que já vieram prontas do servidor só precisam da navegação do slide
    // montada em cima do que já está pintado — sem buscar nem reconstruir os logos.
    let toFetch = [];
    tag.forEach(t => {
      if (t.hasAttribute('data-ws-rendered')) wsMain.modules['manufacturer'].reuse(t);
      else toFetch.push(t);
    });

    if (!toFetch.length) return true;

    let data = await ApiWS.Calls.manufactures();

    toFetch.forEach(t => wsMain.modules['manufacturer'].create(data, t));

    return true;
  },
  reuse(elm) {
    // O servidor já deixa o holder no "frame inicial" do slider via CSS
    // (data-ws-slide-preview) — createSlide() só adiciona a navegação em cima.
    let slideOptions = wsMain.tools.getWsData(elm, 'slide');
    if (slideOptions) {
      let holder = elm.querySelector(':scope > div, :scope > ul');
      if (holder) {
        // createSlide() pega TODOS os filhos do holder (Array.from(elmToSlide.children)),
        // inclusive os que o servidor escondeu com display:none pro "frame inicial" — o
        // KeenSlider tenta medir esses itens invisíveis (largura 0) pra calcular o tamanho
        // de cada slide, e essa conta "explode" pra um valor absurdo. Remove o display:none
        // antes: o próprio KeenSlider passa a controlar quem fica visível de verdade.
        Array.from(holder.children).forEach(child => { if (child.style.display === 'none') child.style.display = ''; });
        // Força o navegador a recalcular o layout AGORA (reflow síncrono) — sem isso o
        // KeenSlider mede o container antes do reflow do display:none acima ter sido
        // processado, e calcula um tamanho de slide absurdo em cima de uma medida velha/
        // inconsistente.
        void holder.offsetHeight;
        let [slideSuccess, slider] = wsMain.tools.createSlide(holder, slideOptions);
        if (slideSuccess && slider) {
          slider.update();
          // Segunda rede de segurança (mesmo padrão do wsapi3-banners.js): reconfere o
          // tamanho depois que o browser realmente pintou o frame.
          setTimeout(() => slider.update(), 50);
        }
      }
    }
    // Seções da home (data-wsjs-container) só ficam visíveis quando dataLoad() sobe a
    // árvore removendo esse atributo — normalmente acontece dentro de replaceSpanTag(),
    // que a gente pulou de propósito aqui.
    wsMain.addons.dataLoad(elm);
  },
  create(returnJson, elm) {
    let fabricantes = returnJson.fabricantes;

    if (!fabricantes || fabricantes.length == 0) return;

    let manufacturerOptions = wsMain.tools.getWsData(elm, 'options');

    if (manufacturerOptions.labelOnly != true) {
      fabricantes = fabricantes.filter((f) => !!f.logotipo);
      if (fabricantes.length == 0) return;
    }

    let divHolder = wsMain.tools.createElm({
      type: "div"
    });

    fabricantes.forEach((f) => {
      let hiperLink = wsMain.tools.createElm({
        type: "a",
        attrs: {
          href: f.url,
          "data-id": "manufacturer-" + f.id,
        },
      });

      if (f.logotipo && manufacturerOptions.labelOnly != true) {
        let fImg = wsMain.tools.createElm({
          type: "img",
          imgArea: 'fabricantes', // Cloudflare Image Resizing (imageResize do head)
          attrs: {
            // Mesma proporção 2:1 do wrapper (.manufacturer-holder .keen-slider__slide a
            // { aspect-ratio: 2/1 }) — reserva o espaço certo antes da imagem carregar.
            width: 140,
            height: 70,
            src: f.logotipo,
            title: f.nome,
            alt: f.nome,
          },
        });
        hiperLink.append(fImg);
        divHolder.append(hiperLink);
      } else {
        let fName = wsMain.tools.createElm({
          type: "li",
          innerHTML: `<span>${f.nome}</span>`,
          attrs: {
            title: f.nome,
          },
        });

        hiperLink.append(fName);
        divHolder.append(hiperLink);
      }
    });

    let slideOptions = wsMain.tools.getWsData(elm, 'slide');

    // Anexa ANTES de montar o slide (era o contrário) — createSlide() mede a largura do
    // container pra calcular o tamanho de cada logo, e um elemento ainda fora do documento
    // sempre mede 0, fazendo a seção alternar entre altura 0 e a altura real logo depois de
    // inserida (empurra e traz de volta tudo abaixo na página). De quebra, no ramo labelOnly
    // isso também corrige um bug pré-existente: criar o slide em cima de divHolder e depois só
    // copiar seu innerHTML pro <ul> final perdia toda referência que o KeenSlider guarda dos
    // nós reais (setas/dots ficavam quebrados) — agora o slide é montado direto no elemento que
    // de fato fica na página.
    let finalElm = manufacturerOptions.labelOnly == true
      ? wsMain.tools.createElm({ type: 'ul', innerHTML: divHolder.innerHTML })
      : divHolder;

    wsMain.tools.replaceSpanTag(finalElm, elm);

    let slideSuccess, slider;

    if (slideOptions) {
      // Mesmo padrão de wsapi3-banners.js: entre o replaceSpanTag acima (todos os logos já
      // no DOM, precisa estar assim pra medida de largura do createSlide() sair certa) e o
      // slider realmente organizado em carrossel, os logos ficam visíveis "crus" (lista
      // simples, um do lado do outro sem o espaçamento/posição do KeenSlider) por um
      // instante — pode aparecer sobreposto/distorcido dependendo do timing. visibility
      // (não display, que zeraria a largura e quebraria a própria medida) esconde só a
      // pintura, sem tirar o espaço do layout — não adiciona salto novo.
      finalElm.style.visibility = 'hidden';
      [slideSuccess, slider] = wsMain.tools.createSlide(finalElm, slideOptions);
      if (slideSuccess) slider.update();
      finalElm.style.visibility = '';
    }

    return true;
  },
});
